import { ChangeDetectorRef, Component,inject, OnInit } from '@angular/core';
import {
  DealerSummaryRequest,
  DealerSummaryResponse,
  MultiDealerSummaryRequest,
  ZIJob,
  ZInv,
  ZInvtab,
} from '../../models/dealer-summary.model';
import {
  DsAccordionModule,
  DsBoxModule,
  DsButtonModule,
  DsColumnData,
  DsHeaderModule,
  DsIconModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsRowData, DsTableModule,
  DsToastModel,
  DsToastService,
} from '@bmw-ds/components';
import { CrossBorderService } from '../../services/crossborder.service';
import { DealerSummaryService } from '../../services/dealer-summary.service';
import { DecimalPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Z11DealerTransfersRequest, Z11GetSalesTypeRequest, Z11GetSalesTypeResponse } from '../../models/holds-transfers.model';
import { HoldsTransfersService } from '../../services/holds-transfers.service';
import { NatisUserRequest, Z11GetUserDetailResponse } from '../../models/user-details.model';
import { AuthService } from '../../services/auth.service';
import { COMMON_IMPORTS } from '../../shared/common-imports';

@Component({
  selector: 'app-dealer-summary',
  imports: [
    NgForOf,
    NgIf,
    DsBoxModule,
    DsIconModule,
    DecimalPipe,
    DsModalModule,
    DsHeaderModule,
    FormsModule,
    DsButtonModule,
    DsAccordionModule,
    DsTableModule,
    NgClass,
    COMMON_IMPORTS
  ],
  templateUrl: './dealer-summary.component.html',
  styleUrl: './dealer-summary.component.scss',
})
export class DealerSummaryComponent implements OnInit {
  dealerSummaryRequest: DealerSummaryRequest = {
    dealer: localStorage.getItem('euserid') || '',
  };
  z11DealerTransfersRequest: Z11DealerTransfersRequest = {
    dealer: this.dealerSummaryRequest.dealer,
  };

  multiDealerSummaryRequest: MultiDealerSummaryRequest = {
    userid: this.dealerSummaryRequest.dealer,
    functionId: '',
    bodyNumber: '',
    accessToken: '',
    domain: 'net',
    vin: '',
  };
  private readonly toastService = inject(DsToastService);
  confirmationModalIsOpen: boolean = false;
  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }

  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Loading...',
  };
  dealerSummary?: DealerSummaryResponse;

  constructor(
    private readonly loadingAreaService: DsLoadingAreaService,
    private readonly dealerSummaryService: DealerSummaryService,
    private readonly holdsTransfersService: HoldsTransfersService,
    private readonly crossBorderService: CrossBorderService,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService
  ) {}
  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
      this.dealerSummaryService
        .getDealerSummary(this.dealerSummaryRequest)
        .subscribe((response: DealerSummaryResponse) => {
          this.dealerSummary = response;
          this.cdr.markForCheck();
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        });
    } else {
      window.location.href = this.authService.getAuthUrl(); // Redirect to the auth URL
    }
  }
  rowsData: DsRowData[] = [];
  columnData: DsColumnData[] = [];

  searchText = '';
  protected readonly console = console;
  currentZseq: string = '';
  summaryModalData = {
    title: '',
  };
  summaryModalIsOpen: boolean = false;

  getTableHeaders(zseq: string): DsColumnData[] {
    const headersMap: { [key: string]: DsColumnData[] } = {
      '001': [
        { field: 'zorder', headerName: 'Order Number' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'z08dlr', headerName: 'Dealer Code' },
        { field: 'zdes_cde', headerName: 'DC' },
        { field: 'stat_code', headerName: 'SC' },
        { field: 'zprodw', headerName: 'Production Week' },
        { field: 'zotp', headerName: 'OTP' },
        { field: 'zdeall_dte', headerName: 'De-allocation Date' },
      ],
      '002': [
        { field: 'zorder', headerName: 'Order Number' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'z08dlr', headerName: 'Dealer Code' },
        { field: 'zdes_cde', headerName: 'DC' },
        { field: 'stat_code', headerName: 'SC' },
        { field: 'zprodw', headerName: 'Production Week' },
        { field: 'zotp', headerName: 'OTP' },
        { field: 'zdeall_dte', headerName: 'De-allocation Date' },
      ],
      '003': [
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'z08dlr', headerName: 'Interior Code' },
        { field: 'zdes_cde', headerName: 'Exterior Code' },
        { field: 'stat_code', headerName: 'Status Code' },
      ],
      '004': [
        { field: 'zorder', headerName: 'Status' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zdes_cde', headerName: 'Days' },
        { field: 'stat_code', headerName: 'RFI Date' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'z08dlr', headerName: 'Model Description' },
        { field: 'zdeall_dte', headerName: 'Invoice Trigger Date' },
      ],
      '005': [
        { field: 'zorder', headerName: 'Order Number' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zact_dte', headerName: 'RFI Date' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'zcol', headerName: 'Interior Code' },
        { field: 'ztrim', headerName: 'Exterior Code' },
        { field: 'zotp', headerName: 'OTP' },
        { field: 'zdeall_dte', headerName: 'De-allocation Date' },
      ],
      '006': [
        { field: 'zorder', headerName: 'Order Number' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'zmodel', headerName: 'Invoice Date' },
        { field: 'z08dlr', headerName: 'Dealer Code' },
        { field: 'zdes_cde', headerName: 'DC' },
        { field: 'stat_code', headerName: 'SC' },
        { field: 'zprodw', headerName: 'Production Week' },
        { field: 'zotp', headerName: 'OTP' },
        { field: 'zdeall_dte', headerName: 'De-allocation Date' },
      ],
      '009': [
        { field: 'action', headerName: '' },
        { field: 'zorder', headerName: 'Order Number' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'zmodel', headerName: 'Invoice Date' },
        { field: 'z08dlr', headerName: 'Dealer Code' },
        { field: 'zdes_cde', headerName: 'DC' },
        { field: 'stat_code', headerName: 'SC' },
        { field: 'zprodw', headerName: 'Production Week' },
        { field: 'zotp', headerName: 'OTP' },
        { field: 'zdeall_dte', headerName: 'De-allocation Date' },
      ],
      '014': [
        { field: 'zorder', headerName: 'Order Number' },
        { field: 'zbody', headerName: 'Body Number' },
        { field: 'zmodel', headerName: 'Model Code' },
        { field: 'z08dlr', headerName: 'Interior Code' },
        { field: 'zdes_cde', headerName: 'Exterior Code' },
        { field: 'stat_code', headerName: 'Retail' },
        { field: 'zotp', headerName: 'Sales Code' },
        { field: 'zdeall_dte', headerName: 'Name' },
        { field: 'zdeall_dte', headerName: 'Engine Number' },
      ],
      // Add other zseq mappings as needed
    };
    return headersMap[zseq] || [];
  }

  zijob: any[] = [];
  natisUserRequest: NatisUserRequest = {
    dealerCode: localStorage.getItem('dealerCode') || '',
    cNumber: localStorage.getItem('userId') || '',
  };

  z11GetSalesTypeRequest: Z11GetSalesTypeRequest = {
    dealer: this.dealerSummaryRequest.dealer,
    veh_type: '1',
  };
  holdsTransferModalIsOpen: boolean = false;
  holdTransfermodalData: { dealerCode: string; dealerName: string } = {
    dealerCode: '',
    dealerName: '',
  };
  z11GetUserDetailResponse?: Z11GetUserDetailResponse;
  z11GetSalesTypeResponse?: Z11GetSalesTypeResponse;
  dealerTransfersResponse: any;

  getData(zseq: string, description: string, total: string) {
    if (total === '0.00' && zseq !== '007' && zseq !== '008') {
      // alert('No data available for this selection:  {{ description}} ');
      this.addToast('critical', 'No data available for this selection');
    } else {
      if (zseq === '007' || zseq === '008') {
        if (total === '0.00') {
          this.addToast('critical', 'No data available for this selection');
          return;
        }
        this.holdsTransfersService
          .getDealerTransfers(this.z11DealerTransfersRequest)
          .subscribe((response) => {
            console.log(response);
            this.dealerTransfersResponse = response;
          });

        //user details
        this.crossBorderService
          .getUserDetails(this.natisUserRequest)
          .subscribe((response) => {
            console.log(response);
            this.z11GetUserDetailResponse = response;
            this.holdTransfermodalData.dealerCode = response.dealer_code || '';
            this.holdTransfermodalData.dealerName = response.dealername || '';
            this.cdr.detectChanges();
          });
        //get sales type

        this.holdsTransfersService
          .getSalesType(this.z11GetSalesTypeRequest)
          .subscribe((response) => {
            console.log(response);
            this.z11GetSalesTypeResponse = response;
          });
        this.cdr.detectChanges();
        this.holdsTransferModalIsOpen = true;
      } else {
        // use userId for parameter usrenc
        //zseq is the rfc code to call
        console.log(description);
        this.summaryModalData.title = description;

        //then call modal
        this.currentZseq = zseq;
        this.multiDealerSummaryRequest.functionId = zseq;
        this.multiDealerSummaryRequest.bodyNumber = '';
        this.multiDealerSummaryRequest.vin = '';
        this.rowsData = [];
        this.dealerSummaryService
          .getMultiDealerSummary(this.multiDealerSummaryRequest)
          .subscribe((response) => {
            console.log(response);
            if (zseq === '001') {
              this.rowsData = (response.zijob || []).map((item: ZIJob) => ({
                zorder: item.zorder,
                zbody: item.zbody,
                zvin: item.zvin,
                zmodel: item.zmodel,
                zmoddesc: item.zmoddesc,
                z08dlr: item.z08dlr,
                zdes_cde: item.zdes_cde,
                stat_code: item.stat_code,
                zprodw: item.zprodw,
                zotp: item.zotp,
                zdeall_dte: item.zdeall_dte,
              }));
              this.cdr.detectChanges();
              this.summaryDeallocationModalIsOpen = true;
            } else if (zseq === '003' || zseq === '010') {
              this.rowsData = (response.zinvtab || []).map((item: ZInvtab) => ({
                zbody: item.zbody || '',
                zmodel: item.zmodel || '',
                z08dlr: item.z08dlr || '',
                zdes_cde: item.zdes_cde || '',
                stat_code: item.stat_code || '',
              }));
              this.cdr.detectChanges();
              this.summaryModalIsOpen = true;
            } else if (zseq === '002' || zseq === '005') {
              this.rowsData = (response.zinvtab || []).map((item: ZInvtab) => ({
                zorder: item.zorder || '',
                zbody: item.zbody || '',
                zact_dte: item.zact_dte || '',
                zmodel: item.zmodel || '',
                zcol: item.zcol || '',
                ztrim: item.ztrim || '',
                zcoldesc: item.zcoldesc || '',
                ztrimdesc: item.ztrimdesc || '',
                zotp: item.zotp || '',
                zdeall_dte: item.zdeall_dte || '',
                zprodw: item.zprodw || '',
                stat_code: item.stat_code || '',
                zdes_cde: item.zdes_cde || '',
                z08dlr: item.z08dlr || '',
                zmoddesc: item.zmoddesc || '',
                zvin: item.zvin || '',
              }));
              this.cdr.detectChanges();
              if(zseq === '002'){
                this.summaryDeallocationFiveDaysModalIsOpen = true;
              }else {
                this.summaryInvoicingReadyModalIsOpen = true;
              }
            } else if (zseq === '006' || zseq === '012' || zseq === '013') {
              this.rowsData = (response.zinv || []).map((item: ZInv) => ({
                zorder: item.zorder || '',
                zbody: item.zbody || '',
                zmodel: item.zmodel || '',
                zmodeldesc: item.zmoddesc || '',
                zinv_dte: item.zinv_dte || '',
                zdlr: item.zdlr || '',
                zdes_cde: item.zdes_cde || '',
                stat_code: item.stat_code || '',
                zprodw: item.zprodw || '',
                zotp: item.zotp || '',
                zvin: item.zvin || '',
                zdeall_dte: item.zdeall_dte || '',
              }));
              this.cdr.detectChanges();
              if(zseq === '006' || zseq === '012'){

                this.summaryInvoiceRejectedModalIsOpen = true;
              }else {
                this.doubleZeroNineModalIsOpen = true;
              }

            } else if (zseq === '009' || zseq === '017') {
              this.rowsData = (response.zinvtab || []).map((item: ZInvtab) => ({
                zorder: item.zorder || '',
                zbody: item.zbody || '',
                zact_dte: item.zact_dte || '',
                zmodel: item.zmodel || '',

                zcol: item.zcol || '',
                ztrim: item.ztrim || '',
                zcoldesc: item.zcoldesc || '',
                ztrimdesc: item.ztrimdesc || '',
                zotp: item.zotp || '',
                zdeall_dte: item.zdeall_dte || '',
                zprodw: item.zprodw || '',
                stat_code: item.stat_code || '',
                zdes_cde: item.zdes_cde || '',
                z08dlr: item.zdlr || '',
                zmoddesc: item.zmoddesc || '',
                zvin: item.zvin || '',
              }));
              this.cdr.detectChanges();
              this.doubleZeroNineModalIsOpen = true;
            }
            // open modal and show data
          });
      }
    }
  }

  onModalClose() {
    this.summaryModalIsOpen = false;
  }

  onHoldsTransferModalClose() {
    this.holdsTransferModalIsOpen = false;
  }
  expandedRow: number | null = null;
  nestedRowsData: any[] = [];
  showOptionsHistory2 = false;
  i: number = 0;
  summaryDeallocationModalIsOpen: boolean = false;
  summaryDeallocationFiveDaysModalIsOpen: boolean = false;
  summaryInvoicingReadyModalIsOpen: boolean = false;
  summaryInvoiceRejectedModalIsOpen: boolean = false;
  doubleZeroNineModalIsOpen: boolean = false;
  modalData = {
    bodyNumberToTransfer: '',
    vinToTransfer: '',

  };


  onRowClick(rowIndex: number, rowData: any) {
    this.i = rowIndex;
    console.log('Row clicked:', rowData, rowIndex);
    this.expandedRow = this.expandedRow === rowIndex ? null : rowIndex;
    // Example: Load nested data for the clicked rowd
    this.nestedRowsData[rowIndex] = this.dealerTransfersResponse?.zpend2;

    console.log(this.nestedRowsData);
  }
  get filteredRowsData() {
    if (!this.searchText) return this.rowsData;
    const search = this.searchText.toLowerCase();
    return this.rowsData.filter((row) =>
      Object.values(row).some(
        (val) => val && val.toString().toLowerCase().includes(search)
      )
    );
  }

  callTransfer(bodyNo: string | number, vin: string | number) {
    console.log('Transfer called for Body No:', bodyNo, 'VIN:', vin);
    this.doubleZeroNineModalIsOpen = false;
    this.confirmationModalIsOpen = true;
    this.modalData.bodyNumberToTransfer = bodyNo.toString();
    this.modalData.vinToTransfer = vin.toString();
  }

  confirmTransfer(bodyNo: string | number, vin: string | number) {
    console.log('Confirm Transfer called for Body No:', bodyNo.toString());
    console.log('VIN:', vin.toString());
    this.confirmationModalIsOpen = false;

      this.multiDealerSummaryRequest.vin = vin.toString();
      this.multiDealerSummaryRequest.bodyNumber = bodyNo.toString();
      this.multiDealerSummaryRequest.functionId = 'TRANSFER';

      this.dealerSummaryService
        .getMultiDealerSummary(this.multiDealerSummaryRequest)
        .subscribe((response) => {
          console.log('Transfer response:', response);
          this.addToast(
            'positive',
            'Unit ' + bodyNo + ' transferred back to Camp successfully.'
          );
          // Optionally, refresh the data or update the UI as needed
        });

  }

  openUnitUpdate(vin: string | number, bodyNo: string | number): void {
    console.log('Transfer called for Body No:', vin.toString());
    console.log('VIN:', bodyNo.toString());
    const url = `/unit-update?vin=${vin}&bodyNo=${bodyNo}`;
    window.open(url, '_blank', 'noopener');
  }

  onDeallocationModalClose() {
    this.summaryDeallocationModalIsOpen = false;
  }

  onDeallocationFiveDaysModalClose() {
    this.summaryDeallocationFiveDaysModalIsOpen = false;
  }

  onInvoicingModalClose() {
    this.summaryInvoicingReadyModalIsOpen = false;
  }

  onInvoiceRejectedModalClose() {
    this.summaryInvoiceRejectedModalIsOpen = false;
  }

  onDoubleZeroNineModalClose() {
    this.doubleZeroNineModalIsOpen = false;
  }

  cancelTransferModalClose() {
    this.confirmationModalIsOpen= false;
  }
}
